import { Injectable } from '@angular/core';
import { QuestionVM } from './question.model';
import { Observable } from 'rxjs/Rx';
import { Http, Response } from '@angular/http';

@Injectable()
export class HomeService {

    private questionsUrl = 'api/questions';
    private messagesUrl = 'api/messages';

    constructor(private http: Http) { }

    getQuestions(): Observable<QuestionVM[]> {
        return this.http.get(this.questionsUrl).map((res: Response) => {
            return res.json() as QuestionVM[];
        });
    };

    getMessages(): Observable<any> {
        return this.http.get(this.messagesUrl).map((res: Response) => {
            return res.json();
        });
    };
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.service.ts